module.exports = __webpack_public_path__ + "static/logo-55a1b12332d537fbcd828f58ac4df4c8.png";